import { render, staticRenderFns } from "./BonusesReportExcel.vue?vue&type=template&id=f23214c8&scoped=true"
import script from "./BonusesReportExcel.vue?vue&type=script&lang=js"
export * from "./BonusesReportExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23214c8",
  null
  
)

export default component.exports